var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "btn-group" }, [
    _c(
      "button",
      {
        staticClass: "btn btn-sm",
        class: { "btn-danger": !_vm.isBound, "btn-secondary": _vm.isBound },
        on: { click: _vm.toggle },
      },
      [
        _c("i", {
          staticClass: "fas",
          class: { "fa-unlink": _vm.isBound, "fa-link": !_vm.isBound },
        }),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }